var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserFilled = function SvgUserFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35 6.792A3.654 3.654 0 0 1 10 3.142a3.66 3.66 0 0 1 3.65 3.65 3.66 3.66 0 0 1-3.65 3.65 3.66 3.66 0 0 1-3.65-3.65Zm11.15 8.491c-1.608-2.741-4.408-4.383-7.492-4.383-3.083 0-5.891 1.642-7.491 4.383a1.03 1.03 0 0 0 0 1.05c.191.325.525.525.9.525h13.2c.375 0 .716-.191.9-.525a1.071 1.071 0 0 0 0-1.05H17.5Z",
    fill: "current"
  })));
};
export default SvgUserFilled;